module.exports = __webpack_public_path__ + "img/VP-ECONew_Overview-GB-EB_1.af4540a5.jpg";